import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const confirmarAcao = (titulo, texto, botaoConfirmar = 'Sim, confirmar') => {
    return MySwal.fire({
        title: titulo,
        text: texto,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#d33',
        confirmButtonText: botaoConfirmar,
        cancelButtonText: 'Cancelar',
        reverseButtons: true
    });
};

export const alertaDeErro = (mensagem) => {
    return MySwal.fire({
        icon: 'error',
        title: 'Ops...',
        text: mensagem,
        confirmButtonColor: '#198754'
    });
};

export const alertaDeSucesso = (mensagem) => {
    return MySwal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: mensagem,
        timer: 2000,
        showConfirmButton: false
    });
};